import { useCallback, useState } from "react";
import axiosInstance from "./base/axios";

const FetchHook = () => {
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState();

  const fetchCallback = useCallback(async (pro) => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(pro.url);
      setData(res);
      return res;
    } catch (err) {
      setData(err);
      console.log(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);
  return [isLoading, data, fetchCallback];
};

export default FetchHook;
